import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { ICaseRepository } from './Icase.repository';
import { ApiResponse, Plan } from './models';


@Injectable({ providedIn: 'root' })
export class CaseRepository implements ICaseRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly config = inject(APP_CONFIG);

	getCase(id: string): Observable<ApiResponse<Plan>> {
		const params = new HttpParams().set('id', id);
		return this.httpClient.get<ApiResponse<Plan>>(this.config.domainPatientAPI + '/api/cases/getcase', { params });
	}
}
